<template>
  <div class="uk-width-1-2@m interactive-voice-main"
  >
    <div class="uk-padding-larger">
      <h4 class="
              uk-text-secondary-muted
              uk-text-uppercase
              uk-text-lighter
              uk-text-medium
              text-spacing-medium uk-margin-small-bottom
              interactive-voice-header"
          v-if="subTitle.length > 0"
      >
        {{subTitle}}
      </h4>
      <h3 class="uk-margin-remove-top text-spacing-large
            uk-heading-small uk-text-lighter uk-text-uppercase uk-text-condensed
            interactive-voice-sub-header"
          :class="{'uk-text-secondary': !primary }"
      v-html="title"></h3>
      <p class="interactive-voice-text" :class="{'uk-text-secondary': !primary }">
        <slot/>
      </p>
      <div class="uk-flex uk-margin-medium-top"></div>
      <audio-block-voorbeeld></audio-block-voorbeeld>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import AudioBlockVoorbeeld from '@/components/AudioBlockVoorbeeld.vue';

export default Vue.extend({
  components: {
    AudioBlockVoorbeeld,
  },
  name: 'ImageSectionToneOfVoice',
  props: {
    primary: {
      type: Boolean,
      default: false,
    },
    title: String,
    subTitle: {
      type: String,
      required: String,
    },
    buttonText: {
      required: false,
      type: String,
    },
    buttonLink: {
      required: false,
      type: String,
    },
  },
  computed: {
    buttonLinkParsed() {
      return this.buttonLink ?? '';
    },
  },
});
</script>
